import { IntegerFilter } from "./integer-filter";
import { StringFilter } from "./string-filter";

export class StateFilter {
    public id?: IntegerFilter;
    public name?: StringFilter;
}
